export const SALARIS = '095c1e80-184e-44d7-8e1d-50e99913fc6d'
export const SPECIAL = '056b5d86-b4ef-4ed6-8e98-e84382eec170'
